<div class="modal-header" style="border: 1px solid #ccc;justify-content: center;">
  <b>Alert</b>
</div>
<div class="modal-body text-center" >
  <b>Session Expired</b>
</div>
<div class="modal-footer" style="justify-content: center;">
    <button type="button" class="btn btn-info" (click)="logout()">Logout</button>
  </div>